<template>
  <el-container style="height:100vh">
    <el-header>
      <div>
        <img src="../assets/logo.png" alt />
        <span>全心脏建模在线平台</span>
      </div>
      <el-button type="info" @click="logout">退出</el-button>
    </el-header>
    <el-container>
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <el-menu
          router
          background-color="#333744"
          text-color="#fff"
          active-text-color="#409EFF"
          unique-opened
          :collapse="isCollapse"
          :collapse-transition="false"
          index
          :default-active="$route.path"
        >
          <el-submenu :index="item.index" v-for="item in menulist" :key="item.id">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{item.name}}</span>
            </template>
            <el-menu-item
              :index="'/'+subItem.index"
              v-for="subItem in item.children"
              :key="subItem.id"
            >
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span>{{subItem.name}}</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      menulist: [],
      isCollapse: false,
    };
  },
  methods: {
    logout() {
      window.sessionStorage.removeItem("token");
      window.sessionStorage.removeItem("username");
      this.$router.push("/login");
    },
    async getMenuList() {
      const { data } = await this.$http.get("user/previlege");
      if (data.status === 100) {
        if (data.data.indexOf("1") !== -1) {
          this.menulist.push({
            index: "1",
            name: "用户管理",
            icon: "iconfont icon-icon_user",
            children: [{ index: "users", name: "用户列表" }],
          });
        }
        if (data.data.indexOf("2") !== -1) {
          this.menulist.push({
            index: "2",
            name: "发布任务",
            icon: "iconfont icon-shangpin",
            children: [{ index: "publishlist", name: "任务列表" }],
          });
        }
        if (data.data.indexOf("3") !== -1) {
          this.menulist.push({
            index: "3",
            name: "处理任务",
            icon: "iconfont icon-danju",
            children: [{ index: "todolist", name: "任务领取" },{ index: "mytodolist", name: "我的任务" }],
          });
        }
        if (data.data.indexOf("4") !== -1) {
          this.menulist.push({
            index: "4",
            name: "数据管理",
            icon: "iconfont icon-baobiao",
            children: [{ index: "datalist", name: "数据列表" }],
          });
        }
      }
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
  },
  created() {
    this.getMenuList();
  },
};
</script>

<style lang="less" scoped>
.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    span {
      margin-left: 15px;
    }
  }
  img {
    width: 50px;
    height: 50px;
  }
}

.el-aside {
  background-color: #333744;
  .el-menu {
    border-right: none;
  }
}

.el-main {
  background-color: #eaedf1;
}

.iconfont {
  margin-right: 10px;
}

.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}
</style>